import { useState, useEffect } from "react";
import { default as checkBot } from "isbot";
import { checkIsBot } from "@tm/utility";

/**
 * Custom hook for client-side bot detection
 * @returns {boolean | null} isBot - true if bot detected, false if not, null if detection not yet complete
 */
export const useBotDetection = (): boolean | null => {
  const [isBot, setIsBot] = useState<boolean | null>(null);

  useEffect(() => {
    // Client-side bot detection
    if (typeof window !== "undefined") {
      const userAgent = window.navigator.userAgent;
      const botDetected = checkIsBot(userAgent, checkBot);
      setIsBot(botDetected);
    }
  }, []);

  return isBot;
};
